var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2304_2280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57333 11.9999C6.48192 11.9996 6.39154 11.9806 6.30782 11.9439C6.2241 11.9072 6.14882 11.8536 6.08666 11.7866L2.84666 8.33994C2.72555 8.21087 2.66067 8.03897 2.66629 7.86206C2.67192 7.68515 2.74759 7.51772 2.87666 7.39661C3.00573 7.27549 3.17763 7.21061 3.35454 7.21624C3.53145 7.22186 3.69888 7.29753 3.82 7.42661L6.56666 10.3533L12.1733 4.21994C12.2302 4.14909 12.301 4.09062 12.3813 4.04812C12.4616 4.00562 12.5498 3.97998 12.6404 3.97279C12.731 3.9656 12.8221 3.97701 12.9081 4.00631C12.9941 4.03561 13.0732 4.08218 13.1406 4.14317C13.2079 4.20416 13.2621 4.27828 13.2998 4.36097C13.3375 4.44366 13.3578 4.53318 13.3597 4.62403C13.3615 4.71488 13.3447 4.80515 13.3104 4.88928C13.276 4.97341 13.2249 5.04964 13.16 5.11327L7.06666 11.7799C7.00509 11.8482 6.93007 11.9029 6.84632 11.9408C6.76257 11.9787 6.6719 11.9988 6.58 11.9999H6.57333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2304_2280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d01cd87d339f570e8b0962ad078e24e1.svg";
export { ForwardRef as ReactComponent };